import { render, staticRenderFns } from "./LawMediationResultForm.vue?vue&type=template&id=2ce4c2dc&"
import script from "./LawMediationResultForm.vue?vue&type=script&lang=js&"
export * from "./LawMediationResultForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMediationResultForm.vue?vue&type=style&index=0&id=2ce4c2dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports